<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.settings' | translate }}
    v-card-content
      v-text-field.mb-5(
        :focus="true"
        :label="$t('base.first_name')"
        :hint="errorMessage('first_name')"
        :invalid="!!errorMessage('first_name')"
        v-model="user.first_name")
      v-text-field.mb-5(
        :label="$t('base.last_name')"
        :hint="errorMessage('last_name')"
        :invalid="!!errorMessage('last_name')"
        v-model="user.last_name")
      v-text-field.mb-5(
        :label="$t('base.phone')"
        :hint="errorMessage('phone')"
        :invalid="!!errorMessage('phone')"
        v-model="user.phone")
      //- v-select.mb-3(
      //-   itemValue="key"
      //-   :label="$t('base.lang')"
      //-   :options="langs"
      //-   v-model="user.profile.language")
      v-text-field(
        :label="$t('base.about_me')"
        v-model="user.profile.about")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="saveChanges") {{ 'base.save' | translate }}
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'SettingsUserModal',

  data: () => ({
    user: {
      first_name: '',
      last_name: '',
      phone: '',
      profile: {
        about: '',
        // language: null
      }
    },
    errors: {
      first_name: '',
      last_name: '',
      phone: ''
    },
    langs: [
      { id: 0, name: 'Українська', key: 'uk' },
      { id: 1, name: 'Русский', key: 'ru' },
      { id: 2, name: 'Polish', key: 'pl' },
      { id: 3, name: 'English', key: 'en' },
      { id: 4, name: 'Nederlands', key: 'nl' },
      { id: 5, name: 'Deutschland', key: 'de' },
      { id: 6, name: 'France', key: 'fr' },
      { id: 7, name: 'Italia', key: 'it' },
      { id: 8, name: 'România', key: 'ro' },
      { id: 9, name: 'USA', key: 'us' },
    ],
    loading: false
  }),

  mounted () {
    this.loadData()
  },
  mixins: [formErrorsMixin],
  methods: {
    async loadData () {
      const { data } = await api.account.get()
      const {
        first_name: firstName,
        last_name: lastName,
        phone,
        profile
      } = data
      this.user.first_name = firstName
      this.user.last_name = lastName
      this.user.phone = phone
      this.user.profile.about = profile.about
      // this.user.profile.language = profile.language
    },

    async saveChanges () {
      this.loading = true
      const payload = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        profile: {
          about: this.user.profile.about,
          // language: this.user.profile.language
        }
      }
      this.checkValidData()
      this.loading = false
      if (this.errors.first_name === null && this.errors.last_name === null && this.errors.phone === null) {
        const { errors } = await api.account.update(payload)

        if (!errors) {
          this.$toasted.show(this.$t('info.changed'))
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.unexpected'))
          this.errors = errors
        }
      }
    },
    checkValidData () {
      this.errors.first_name = null
      this.errors.last_name = null
      this.errors.phone = null

      if (!this.user.first_name) {
        this.errors.first_name = this.errors.first_name = ['3']
      } else if (this.user.first_name.length > 30) {
        this.errors.first_name = this.errors.first_name = ['6', 30]
      }
      if (!this.user.last_name) {
        this.errors.last_name = this.errors.last_name = ['3']
      } else if (this.user.last_name.length > 30) {
        this.errors.last_name = this.errors.last_name = ['6', 30]
      }
      if (!this.user.phone) {
        this.errors.phone = this.errors.phone = ['3']
      } else if (this.user.phone.length > 15) {
        this.errors.phone = this.errors.phone = ['6', 15]
      }
    },
    onLangChange ({ key }) {
      this.$store.dispatch('account/setLang', key)
    }
  }
}
</script>
